import {
  CONFIRMATION_HINTS, CONFIRMATION_LABELS, INCIDENT_SEVERITY_LABELS, INCIDENT_STATE_LABELS, PRIORITY_LABELS, incidentStateTone, severityTone, RELEASE_STATE_LABELS, STATUS_LABELS, TYPE_LABELS, confirmationTone, priorityTone, releaseTone, statusTone,
  typeTone,
} from "../../lib/product";

function Pill({ tone, children, testid }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${tone}`} data-testid={testid}>
      {children}
    </span>
  );
}

export function StatusBadge({ status, testid = "product-status" }) {
  return <Pill tone={statusTone(status)} testid={testid}>{STATUS_LABELS[status] || status}</Pill>;
}

export function TypeBadge({ type, testid = "product-type" }) {
  return <Pill tone={typeTone(type)} testid={testid}>{TYPE_LABELS[type] || type}</Pill>;
}

// `compact` drops the word « Priorité » where the column or the label already says it.
export function PriorityBadge({ priority, compact = false, testid = "product-priority" }) {
  if (!priority) return null;
  const label = PRIORITY_LABELS[priority] || priority;
  return <Pill tone={priorityTone(priority)} testid={testid}>{compact ? label : `Priorité ${label.toLowerCase()}`}</Pill>;
}

export function ReleaseStateBadge({ state, testid = "release-state" }) {
  return <Pill tone={releaseTone(state)} testid={testid}>{RELEASE_STATE_LABELS[state] || state}</Pill>;
}

// « Confirmée en production » or « Déclarée, non confirmée »; nothing while the version is only planned.
export function ConfirmationBadge({ confirmation, testid = "release-confirmation" }) {
  if (!confirmation || confirmation === "none") return null;
  return (
    <span title={CONFIRMATION_HINTS[confirmation]} data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${confirmationTone(confirmation)}`}>
      {CONFIRMATION_LABELS[confirmation]}
    </span>
  );
}

export function SeverityBadge({ severity, testid = "incident-severity" }) {
  return <Pill tone={severityTone(severity)} testid={testid}>{INCIDENT_SEVERITY_LABELS[severity] || severity}</Pill>;
}

export function IncidentStateBadge({ state, testid = "incident-state" }) {
  return <Pill tone={incidentStateTone(state)} testid={testid}>{INCIDENT_STATE_LABELS[state] || state}</Pill>;
}
